import React from 'react';
import PropTypes from 'prop-types';

import Grid from 'shared-components/components/Grid';

import { createSeoFooterForBigCities } from '../helpers/seoFooter';

import '../SeoFooter.css';

const SeoFooterBigCities = ({ data }) => {
  const { affitto = [], vendita = [] } = data;

  if (!affitto.length && !vendita.length) {
    return null;
  }

  return (
    <Grid className="seoList sw" justify="space-between">
      <div className="regionsContainer seoBGContainer">
        <Grid className="regionsList seoBGCList">
          <Grid className="seoBGCColumn" direction="column" role="region" aria-labelledby="big-cities-sale">
            <p className="tp-w--l tp-s--x2l mb--m" id="big-cities-sale">
              Case in vendita nelle principali città italiane
            </p>
            <ul className="listBGC noPoint">
              {createSeoFooterForBigCities({ list: vendita, ptypeForLinks: 'tutte le case in vendita' })}
            </ul>
          </Grid>
          <Grid className="seoBGCColumn" direction="column" role="region" aria-labelledby="big-cities-rent">
            <p className="tp-w--l tp-s--x2l mb--m" id="big-cities-rent">
              Affitti nelle principali città italiane
            </p>
            <ul className="listBGC noPoint">
              {createSeoFooterForBigCities({ list: affitto, ptypeForLinks: 'tutte le case in affitto' })}
            </ul>
          </Grid>
        </Grid>
      </div>
    </Grid>
  );
};

export default SeoFooterBigCities;

SeoFooterBigCities.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};
